import React, { useState, useEffect, useContext } from "react";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import style from "./index.module.scss";
import PubSub from "pubsub-js";

import User from "./user/index";
import logo from "@/assets/images/logo.png";
import { rootContext, globalData } from "@/context/rootContext";
import { mainOfGame, mainOfRegion, isFl84, isSea } from "@/common/utils/envData";
import { Cascader } from "antd";
import { filterGameNavList } from "@/common/filter";
import filterGameData from "@/assets/data/gameData";

const seaLangList = [
  { key: "en", language: "English" },
  { key: "vi", language: "Tiếng Việt" },
  { key: "th", language: "ภาษาไทย" },
  { key: "id", language: "Bahasa Indonesia" },
];

let preLocation = "";

function Header() {

  const location = useLocation();
  const navigate = useNavigate();
  const [type, setType] = useState(0);
  const [isShowTip, setIsShowTip] = useState(false);
  const [homeFix, setHomeFix] = useState(true);
  const [headWhite, setHeadWhite] = useState(false);
  const [gameTagList, setGameTagList] = useState(null);
  const [gameTagActiveValue, setGameTagActiveValue] = useState([]);
  const [popupVisible, setPopupVisible] = useState(false);

  const {
    langState, isLogin, setDialogIndex, protocols,
    activeGame, setActiveGame, creatorData,
    headFixed, globalLang, setGlobalLang
  } = useContext(rootContext);

  const pageList = [
    { pathname: "/", name: "主页" },
    { pathname: "/application", name: "申请页" },
    { pathname: "/signup", name: "注册" },
    { pathname: "/guide", name: "引导" },
    { pathname: "/admin", name: "个人首页" },
    { pathname: "/information", name: "个人信息" }
  ];

  const swipetHeaderType = (_pathname) => {
    switch (true) {
      case _pathname.includes(pageList[1].pathname):
        setType(1);
        break;
      case _pathname.includes(pageList[2].pathname):
        setType(5);
        break;
      case _pathname.includes(pageList[3].pathname):
        setType(2);
        break;
      case _pathname.includes(pageList[4].pathname):
        setType(3);
        break;
      case _pathname === pageList[0].pathname:
        setType(0);
        break;
      case _pathname.includes(pageList[5].pathname):
        setType(4);
        break;
    }
  };

  const clickTopLogo = () => {
    if (location.pathname.includes("/guide")) {
      return;
    }
    if (!isLogin && location.pathname === "/") {
      window.scrollTo(0, 0);
    }
    if (isLogin && creatorData && creatorData.isCreator) {
      navigate("/admin/home");
    } else {
      console.log(1);
      navigate("/");
    }
  };

  const resetActiveGameTag = (item, index) => {
    globalData.activeGameData = item;
    if (isShowTip) {
      setIsShowTip(false);
    }
    for (const item2 of protocols) {
      if (item2.gameTag === item.tag) {
        if (item2.sign) {
          navigate("/admin");
        } else {
          navigate("/sign");
        }
        setActiveGame(index);
        return;
      }
    }
    // 若无签约记录 转授权页
    if (!protocols.length || !protocols.filter(item => item.sign).length) {
      navigate("/sign");
      return;
    }
    // 其他情况 转管理页正常
    setActiveGame(index);
    navigate("/admin");
  };

  const setHeadBg = () => {
    if (homeFix) {
      const vh = document.documentElement.clientHeight;
      const sh = document.documentElement.scrollTop;
      if (sh > vh || ((isFl84 || mainOfRegion) && sh > vh / 2)) {
        setHeadWhite(true);
      } else {
        setHeadWhite(false);
      }
    }
  };

  const enterSignPage = () => {
    // fl84独立区直接进入注册页
    // if (mainOfGame || mainOfRegion) {
    //   navigate("/signup");
    // } else {
    //   navigate("/signuplanguage");
    // }
    // 0227 合并3区
    navigate("/signup");
  };

  const onChangeNav = (value, selectedOptions) => {
    const item = selectedOptions[selectedOptions.length - 1].data;
    // setGameTagActiveValue(value);
    resetActiveGameTag(item, item.index);
  };

  // 进入下一页
  const pageNext = (pathname) => {
    preLocation = pathname;
    swipetHeaderType(pathname);
    if (!location.pathname.includes("/admin")) {
      // 切换主页面，返回顶部
      window.scrollTo(0, 0);
    }
  };

  // 东南亚区切换语言
  const exchangeLanguage = (lang) => {
    globalData.lang = lang;
    setGlobalLang(lang);
    localStorage.setItem("lilacLocale", lang);
  };

  // fl84区设置折叠导航
  useEffect(() => {
    if (!mainOfGame) { return; }
    if (!isLogin) { setGameTagList(null); }
    if (creatorData && creatorData.games && creatorData.games.length) {
      const navList = filterGameNavList(creatorData.games);
      if (navList.length) {
        setGameTagList(navList);
      }
    }
  }, [creatorData, isLogin]);

  // fl84 导航栏切换
  useEffect(() => {
    if (!mainOfGame) { return; }
    if (!gameTagList) { return; }
    if (!globalData.activeGameData.tag) { return; }
    // console.log(globalData.activeGameData.tag, globalData.activeGameData.regionName);
    const tag = globalData.activeGameData.tag;
    const regionId = +globalData.activeGameData.regionId;
    const newChack = [];
    for (const item of gameTagList) {
      if (item.value === tag) {
        newChack.push(item.value);
        if (item.children) {
          for (const subItem of item.children) {
            if (+subItem.data.regionId === regionId) {
              newChack.push(subItem.value);
              break;
            }
          }
        }
        break;
      }
    }
    if (newChack.length > 0) {
      setGameTagActiveValue(newChack);
    }
  }, [gameTagList, activeGame]);

  // 登录后校验
  useEffect(() => {
    const nextPage = location.pathname;
    if (preLocation === nextPage) { // 进入相同页面，不处理
      return;
    }
    if (nextPage.includes("/signup") || nextPage === "/") { // 进入注册页/主页 无要求
      pageNext(nextPage);
      return;
    }
    if (!isLogin || !creatorData) { // 未登录/获取数据完成 结束
      // 避免进入操作页
      if (nextPage.includes("/sign") || nextPage.includes("/guide")) {
        navigate("/");
      }
      return;
    }
    if (nextPage.includes("/sign") || nextPage.includes("/guide")) { // 已登录 进入签约/欢迎页 无要求
      pageNext(nextPage);
      return;
    }
    if (!creatorData.isCreator || !creatorData.realInfo.length) { // 已登录 不是创作者 签署协议为0 只可进入申请页或内页
      if (nextPage === "/" || nextPage.includes("/application")) {
        pageNext(nextPage);
      } else {
        navigate("/");
      }
      return;
    }
    for (const item of protocols) { // 游戏是否已签署社区协议
      if (item.gameTag === globalData.activeGameData.tag) {
        if (!item.sign) {
          // 未签署 进入签约页
          navigate("/sign");
          return;
        }
        break;
      }
    }
    pageNext(nextPage);
  }, [location, isLogin, creatorData]);

  useEffect(() => {
    const scrollFun = setHeadBg;
    if (location.pathname === "/") {
      setHomeFix(true);
      window.addEventListener("scroll", scrollFun);
    } else {
      setHomeFix(false);
      window.removeEventListener("scroll", scrollFun);
    }
  }, [location, homeFix]);

  useEffect(() => {
    if (!isShowTip) {
      PubSub.subscribe("changeGameTip", () => {
        setIsShowTip(true);
      });
    }
  }, [isShowTip]);

  useEffect(() => {
    if (creatorData && creatorData.games.length && !globalData.activeGameData) {
      resetActiveGameTag(creatorData.games[0]);
    }
  }, [creatorData]);

  return (
    <header>
      <div className={`
        ${style.head_wrap}
        ${homeFix ? style.homeFix : ""}
        ${headWhite ? style.white : ""}
        ${mainOfGame && isFl84 && type === 0 ? style.fl84 : ""}
        ${mainOfRegion && type === 0 ? style.isAfk : ""}
        ${mainOfRegion && headWhite ? style.opacity : ""}
      `}>
        <div id="pc_head" className={`
          head_contain
          ${style.head_contain}
          ${headFixed ? style.fixed : ""}
          ${mainOfGame && isFl84 && type === 0 ? style.fl84 : ""}
          ${headWhite ? style.opacity : ""}
        `}>
          <div className={style.logo} onClick={clickTopLogo}>
            <img src={logo} alt="" />
          </div>
          {
            mainOfGame && isFl84 && type === 0 && (
              <div className={style.fl84_logo}></div>
            )
          }
          {
            // 主页
            !isLogin && type === 0 ?
              <div className={style.btn_list}>
                <div className={style.sign_up} onClick={() => { window.gtag("event", "pc_sign"); enterSignPage(); }}>{langState.topNavData.signUp}</div>
                <div className={style.log_in} onClick={() => { window.gtag("event", "pc_login"); setDialogIndex(1); }}>{langState.topNavData.logIn}</div>
              </div>
              : ""
          }
          {
            // 注册
            !isLogin && type === 5 ?
              <div className={style.btn_list2}>
                <div className={style.log_in} onClick={() => { window.gtag("event", "pc_login"); setDialogIndex(1); }}>{langState.topNavData.logIn}</div>
              </div>
              : ""
          }
          {
            // 个人页 - 游戏切换
            isLogin && type === 3 && (
              mainOfGame && gameTagList ? (
                <Cascader
                  value={gameTagActiveValue}
                  className={`gameList ${style.gameList}`}
                  options={gameTagList}
                  expandTrigger="hover"
                  allowClear={false}
                  displayRender={(label) => label[label.length - 1]}
                  getPopupContainer={() => document.getElementById("pc_head")}
                  onChange={onChangeNav}
                  open={popupVisible}
                  onMouseEnter={() => { setPopupVisible(true); }}
                  onMouseLeave={() => { setPopupVisible(false); }}
                />
              ) : (
                <div className={`gameList ${style.gameList}`}>
                  <p className={`${creatorData && (creatorData.games.length > 1) ? style.active : ""}`}>
                    {creatorData && creatorData.games[activeGame] && creatorData.games.length > 0 ? (filterGameData("gameTag")[creatorData.games[activeGame].tag] || creatorData.games[activeGame].tag) : ""}
                  </p>
                  <div className={style.game_nav}>
                    <ul>
                      {
                        creatorData && creatorData.games.map((item, index) => {
                          return (
                            <li
                              className={index === activeGame ? style.active : ""}
                              key={index}
                              onClick={() => { resetActiveGameTag(item, index); }}
                            >
                              {filterGameData("gameTag")[item.tag] || item.tag}
                            </li>
                          );
                        })
                      }
                    </ul>
                  </div>
                  {isShowTip && <div className={`change_tip ${style.change_tip}`}></div>}
                </div>
              )
            )
          }
          {
            isSea &&
            <>
              <div className={style.lang}>
                <div className={style.lang_list}>
                  {
                    seaLangList.map(item => {
                      return <p key={item.key} className={globalLang === item.key ? style.active : ""} onClick={() => { exchangeLanguage(item.key); }}>{item.language}</p>;
                    })
                  }
                </div>
              </div>
            </>
          }
          {
            // 首页 已登录
            isLogin && type === 0 ?
              <div className={`nav_list ${style.nav_list}`}>
                {creatorData && !creatorData.isCreator && <NavLink to={"/application"}>{langState.topNavData.application}</NavLink>}
                <User></User>
              </div>
              : ""
          }
          {
            // 签署协议
            isLogin && type === 2 ?
              <div className={`${style.nav_list} nav_list`}>
                {/* <NavLink to=""}>HOME</NavLink> */}
                <User onlogup={true}></User>
              </div>
              : ""
          }
          {
            // 申请
            isLogin && type === 1 ?
              <div className={`${style.nav_list} nav_list`}>
                <NavLink to={""}>{langState.topNavData.home}</NavLink>
              </div>
              : ""
          }
          {
            // 个人页
            isLogin && type === 3 ?
              <div className={`${style.nav_list} nav_list`}>
                <div className={`${style.user_level} ${style["level" + (+(globalData.activeGameData.accountLv || 1))]}`}></div>
                <User></User>
              </div>
              : ""
          }
          {
            // 个人数据
            isLogin && type === 4 ?
              <div className={`${style.nav_list} nav_list`}>
                <div className={`back_btn ${style.back_btn}`} onClick={() => { window.history.back(); }}>&lt;{langState.topNavData.back}</div>
                <User></User>
              </div>
              : ""
          }
          {isLogin && <div className={style.bug_item} onClick={() => { setDialogIndex(16); }}></div>}
        </div>
      </div>
    </header>
  );
}

export default Header;
